import {
  ChangeDetectorRef,
  Directive,
  Input,
  OnDestroy,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { Subscription } from 'rxjs';

import { AccessService } from '../services/access.service';

/**
 * Структурная директива доступа (F2).
 *
 * Использование:
 *   <button *hasPerm="'capex:edit'">…</button>
 *   <ng-container *hasPerm="'calc_result.export'">…</ng-container>
 *
 * Рендерит содержимое только при granted. denied/not_applicable → элемент убирается.
 * Не путать с тарифными «замочками» (`block_*`) — это отдельный механизм.
 */
@Directive({ selector: '[hasPerm]' })
export class HasPermDirective implements OnDestroy {
  private _expr = '';
  private _hasView = false;
  private _sub?: Subscription;

  @Input()
  set hasPerm(expr: string) {
    this._expr = expr;
    this._subscribe();
  }

  constructor(
    private readonly _tpl: TemplateRef<unknown>,
    private readonly _vcr: ViewContainerRef,
    private readonly _access: AccessService,
    private readonly _cdr: ChangeDetectorRef,
  ) {}

  private _subscribe(): void {
    this._sub?.unsubscribe();
    if (!this._expr) {
      this._render(false);
      return;
    }
    this._sub = this._access.canExpr$(this._expr).subscribe((allowed) => {
      this._render(allowed);
      this._cdr.markForCheck();
    });
  }

  private _render(allowed: boolean): void {
    if (allowed && !this._hasView) {
      this._vcr.createEmbeddedView(this._tpl);
      this._hasView = true;
    } else if (!allowed && this._hasView) {
      this._vcr.clear();
      this._hasView = false;
    }
  }

  ngOnDestroy(): void {
    this._sub?.unsubscribe();
  }
}
